import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=880a0374&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=880a0374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880a0374",
  null
  
)

export default component.exports